import axios from '../request'

export default{
    getBook(data){//获取活动信息
        return axios({
            url:'/portal/tougao/qchhrList ',
            method:'post',
            data
        })
    },
    getlist(data){//获取列表
        return axios({
            url:'/portal/tougao/getQcList',
            method:'post',
            data
        })
    },
    getUserInfo(data = {}){//获取用户信息
        return axios({
            url:`/portal/tougao/getUserInfo`,
            method:'post',
            data
         })
     },
      toUp(data = {}){//给作品点赞
        return axios({
            url:`https://pub-userapi.voc.com.cn/Tougao/tougaoUp `,
            method:'post',
            data
         })
     },
    getCertificate(data = {}){//获取证书
        return axios({
            url:`/portal/tougao/qchhrCertificate`,
            method:'post',
            data
         })
     },
     sendCode(data = {}){//发送验证码
        return axios({
            url:`/portal/tougao/mobileSendCode`,
            method:'post',
            data
         })
     },
     wechatMobile(data = {}){//绑定手机号
        return axios({
            url:`/portal/tougao/wechatMobile`,
            method:'post',
            data
         })
     },
}